import script from "./ArtifactTableRowActions.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArtifactTableRowActions.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__